import { combineReducers } from 'redux';
import * as constants from './actions';

const data = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_COUNTRY_CKU_MAP_BY_ID_SUCCESS:
    case constants.FETCH_CB_CLUSTER_MAP_BY_ID_SUCCESS:
    case constants.FETCH_CB_AREA_MAP_BY_ID_SUCCESS:
    case constants.FETCH_CB_THANA_MAP_BY_ID_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const partners = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_PARTNERS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const partners_with_transaction = (state = [], action) => {
  switch (action.type) {
    case constants.FETCH_PARTNERS_WITH_TRANSACTION_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const partnersUpdate = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_PARTNER_UPDATE_DATA_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const partnerTransactionsSummary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_PARTNER_TRANSACTION_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  data,
  partnersUpdate,
  partnerTransactionsSummary,
  partners,
  partners_with_transaction
});

export const getCkuMapData = state => {
  return state.user.cku.map;
};

export const getPartners = state => {
  return state.user.cku.map.partners;
};

export const getPartnersWithTransaction = state => {
  return state.user.cku.map.partners_with_transaction;
};
